import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, Fragment } from "react";
import {TextField,
        FormHelperText,
        FormControl,
        InputLabel,
        Grid,
        InputAdornment,
        NativeSelect,
        Box,
        Typography,
        Switch
} from "@material-ui/core";
import {Autocomplete} from '@material-ui/lab';
//import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import LabelIcon from '@material-ui/icons/Label';
import ReceiptIcon from '@material-ui/icons/Receipt';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import classnames from "classnames";
import useStyles from './styles';
import { useUserState } from "../../context/UserContext";
import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SelectJobTestingScopes from '../Job/SelectJobTestingScopes';
import '../Job/SelectJobTestingScopes.css'
import './JobDetails.css'

registerLocale('en-NZ', enNZ);


const JobDetails = forwardRef((props, ref) => {
//export default function CreateSite(props, ref) {
    // global
    const { onFormUpdated, onJobDetailsUpdated, onRegionSelected, onIsInRegionSelected, onJobDetailsCreated, getSiteName, onTestingScopesChanged/*, onInstructionsUpdated*/ } = props
    var { regions } = useUserState();
    const classes = useStyles();

    const formRef = useRef(null);
    const [newJob, setNewJob] = useState({...props.createdJob});
    const [customer, setCustomer] = useState({...props.selectedCustomer});
    const [regionOptions, setRegionOptions] = useState([]);

    const [selectedRegionId, setSelectedRegionId] = React.useState(-1);
    const [selectedIsInRegion, setSelectedIsInRegion] = React.useState('YES');
    const [selectedOrderNo, setSelectedOrderNo] = React.useState('-1');
    const [selectedStart, setSelectedStart] = React.useState();
    const [selectedFinish, setSelectedFinish] = React.useState();
    const [isTimeRangeInvalid, setIsTimeRangeInvalid] = React.useState(false);
    const [noRegionSelectedError, setNoRegionSelectedError] = React.useState(false);
    var currentStartValue = null;
    var currentFinishValue = null;
    const startCalendarRef = useRef(null);
    const finishCalendarRef = useRef(null);
    const [startOpen, setStartOpen] = React.useState(false);
    const [finishOpen, setFinishOpen] = React.useState(false);
    var orderNumberRef = useRef(null);
    const [disableOrderNumberField, setDisableOrderNumberField] = React.useState(false);
    const selectJobTestingScopesRef = useRef(null);
    const [testScopesSelected, setTestScopesSelected] = useState([]);

    const APPROVED_LIMIT_PREFIX = 'Approved limit:';
    const legacyApprovedLimitType =
      props.isEditJob &&
      !newJob.completed &&
      !newJob.approved_limit_type &&
      customer?.approved_limit_type
        ? customer.approved_limit_type
        : null;

    const approvedLimitTypeForDisplay = newJob.approved_limit_type || legacyApprovedLimitType;

    const approvedLimitTypeMismatch =
    props.isEditJob &&
    !newJob.completed &&
    newJob.approved_limit_type &&
    customer?.approved_limit_type &&
    newJob.approved_limit_type !== customer.approved_limit_type;

    const errorStyle = {
      color: '#f44336 !important',
      borderColor: '#f44336 !important'
    }

    useImperativeHandle(ref, () => ({
      saveJobDetails() {
        formRef.current.dispatchEvent(new Event('submit'))
      },
      updateInstructions(instructions) {
        // only use for the retesting:
        // everytime scheduler clicks on a past retest row
        setNewJob({
          ...newJob,
          instructions: instructions,
        });
      }

    }));

    useEffect(() => {
      if (props.selectedCustomer !== undefined && props.selectedCustomer !== null) {
        setCustomer({...props.selectedCustomer});
      }
    }, [props.selectedCustomer]);

    useEffect(() => {
      var tempRegions = [];
      tempRegions.push(<option key="0" aria-label="None" value="" />);
      if (regions !== undefined) {
          regions.map(region => {
            if (region.id) {
              tempRegions.push(<Fragment key={region.id}><option value={region.id}>{region.name}</option></Fragment>)
            }
            return tempRegions;
          });
      }
      setRegionOptions(tempRegions);
    }, [regions]);


    useEffect(() => {
       setDisableOrderNumberField(selectedOrderNo === null || selectedOrderNo === undefined || selectedOrderNo === '-1');
    }, [selectedOrderNo]);

    useEffect(() => {
       if(!disableOrderNumberField && selectedOrderNo === '3' &&
         orderNumberRef !== null && orderNumberRef !== undefined &&
         orderNumberRef.current != null && orderNumberRef.current !== undefined) {
           // does not focus:
           //orderNumberRef.current.focus();
           // works:
           document.getElementById('code').focus();
       }
    }, [disableOrderNumberField, selectedOrderNo]);

    useEffect(() => {
        onTestingScopesChanged(testScopesSelected);
    }, [testScopesSelected]);
    // only use this props.isInRegion in create job
  /*  useEffect(() => {
      if (props.isInRegion !== undefined && props.isInRegion !== null) {
         setSelectedIsInRegion(props.isInRegion);
      }
    }, [props.isInRegion]);*/

     useEffect(() => {
       const jobIsNotEmpty = !(newJob && Object.keys(newJob).length === 0 && newJob.constructor === Object);
       if (jobIsNotEmpty) {
         if (newJob.contact === undefined || newJob.contact === null || newJob.contact === '' ||
             newJob.code === undefined || newJob.code === null || newJob.code.trim() === '' ||
             newJob.start === undefined || newJob.start === null || newJob.start === '' ||
             newJob.finish === undefined || newJob.finish === null || newJob.finish === '' ||
             newJob.franchise_id === undefined || newJob.franchise_id === null || newJob.franchise_id < 0 ||
             newJob.instructions === undefined || newJob.instructions === null || newJob.instructions === '' ||
             (newJob.testing_scopes === undefined || newJob.testing_scopes === null || newJob.testing_scopes.length <= 0) ||
             (newJob.testing_scopes !== undefined && newJob.testing_scopes !== null && newJob.testing_scopes.length > 0 &&
               ((newJob.testing_scopes.find(item => item !== undefined && item !== null && (item.name !== undefined && item.name !== null && item.name.toLowerCase().includes('please make a note'))) !== undefined) &&
                 (newJob.testing_scope_other_notes== undefined || newJob.testing_scope_other_notes === null || newJob.testing_scope_other_notes === '')))) {

             if (newJob.franchise_id !== undefined && newJob.franchise_id > 0) {
                 setSelectedRegionId(newJob.franchise_id);
             }
             if (newJob.start !== undefined && newJob.start !== null && newJob.start !== '' &&
                 newJob.finish !== undefined && newJob.finish !== null && newJob.finish !== '') {
                   var d1 = new Date(newJob.start);
                   var d2 = new Date(newJob.finish);
                   setSelectedStart(new Date(newJob.start));
                   setSelectedFinish(new Date(newJob.finish));
             }
             /*f (newJob.contact !== undefined && newJob.contact > 0) {
               setNewJob({
                 ...newJob,
                 contact: newJob.contact,
               });
             }*/
             onFormUpdated(false);
         }
         else {
           var d1 = new Date(newJob.start);
           var d2 = new Date(newJob.finish);
           onFormUpdated(d1 < d2);
           setSelectedStart(new Date(newJob.start));
           setSelectedFinish(new Date(newJob.finish));
           setSelectedRegionId(newJob.franchise_id);
         }
         onJobDetailsUpdated(newJob);
         setSelectedIsInRegion(newJob.is_in_region === undefined || newJob.is_in_region === null || newJob.is_in_region ? "YES" : "NO");

         if (newJob.code !== undefined && newJob.code !== null) {
           if (newJob.code === getSiteName()) {
             setSelectedOrderNo('0');
           }
           else if (newJob.code === 'GET ON SITE') {
             setSelectedOrderNo('1');
           }
           else if (newJob.code === 'TBA BY KEY CONTACT') {
             setSelectedOrderNo('2');
           }
           else {
             setSelectedOrderNo('3');
           }
         }
         else {
           setSelectedOrderNo('-1');
         }
       }
     }, [newJob]);

     useEffect(() => {
        if (
          props.createdJob !== undefined &&
          props.createdJob !== null &&
          (
            newJob.approved_limit_type !== props.createdJob.approved_limit_type ||
            newJob.approved_limit_value !== props.createdJob.approved_limit_value
          )
        ) {
          setNewJob({
            ...newJob,
            approved_limit_type: props.createdJob.approved_limit_type,
            approved_limit_value: props.createdJob.approved_limit_value
          });
        }
      }, [
        props.createdJob?.approved_limit_type,
        props.createdJob?.approved_limit_value
      ]);

      useEffect(() => {
        const updatedInstructions = updateApprovedLimitInstruction(
          newJob.instructions,
          newJob.approved_limit_type,
          newJob.approved_limit_value
        );

        if (updatedInstructions !== (newJob.instructions || '')) {
          setNewJob(prevJob => ({
            ...prevJob,
            instructions: updatedInstructions
          }));
        }
      }, [
        newJob.approved_limit_type,
        newJob.approved_limit_value
      ]);

     /*useEffect(() => {
        console.info('customer changed', customer);

        if (customer !== null && customer !== undefined) {

          if (customer.jsa_required !== null && customer.jsa_required !== undefined) {
              setNewJob({
                ...newJob,
                jsa_required: newJob.jsa_required === null || newJob.jsa_required === undefined ? customer.jsa_required : newJob.jsa_required
              });
          }

          if (customer.microwave_only !== null && customer.microwave_only !== undefined) {
              setNewJob({
                ...newJob,
                microwave_only: newJob.microwave_only === null || newJob.microwave_only === undefined ? customer.microwave_only : newJob.microwave_only
              });
          }

        }
     }, [customer]);*/


      function getApprovedLimitInstruction(type, value) {
        if (
          !type ||
          value === undefined ||
          value === null ||
          value === '' ||
          Number(value) <= 0
        ) {
          return null;
        }

        const numberValue = Number(value);

        if (type === 'TAGS') {
          return `Approved limit: Maximum ${numberValue} ${numberValue === 1 ? 'tag' : 'tags'}. Do not exceed without prior approval.`;
        }

        if (type === 'HOURS') {
          return `Approved limit: Maximum ${numberValue} ${numberValue === 1 ? 'hour' : 'hours'}. Do not exceed without prior approval.`;
        }

        return null;
      }

      function updateApprovedLimitInstruction(instructions, type, value) {
        const approvedLimitInstruction = getApprovedLimitInstruction(type, value);

        const existingLines = (instructions || '')
          .split('\n')
          .filter(line => !line.startsWith(APPROVED_LIMIT_PREFIX));

        const remainingInstructions = existingLines.join('\n').trim();

        if (!approvedLimitInstruction) {
          return remainingInstructions;
        }

        return remainingInstructions
          ? `${approvedLimitInstruction}\n\n${remainingInstructions}`
          : approvedLimitInstruction;
      }

      function handleChange(e) {
         let value = e.target.value;

         if (e.target.name === 'approved_limit_value' && value === '') {
           value = null;
         }

         if (
           e.target.name === 'approved_limit_value' &&
           !newJob.approved_limit_type &&
           legacyApprovedLimitType &&
           value !== null
         ) {
           setNewJob({
             ...newJob,
             approved_limit_type: legacyApprovedLimitType,
             approved_limit_value: value
           });
         }
         else {
           setNewJob({
             ...newJob,
             [e.target.name]: value,
           });
         }
       }

   function handleChangeRegion(e) {
     //console.log('handleChangeRegion', newJob);
     setNewJob({
       ...newJob,
       franchise_id: e.target.value,
     });
     setSelectedRegionId(e.target.value);
     onRegionSelected(e.target.value);
   }

   function handleChangeIsInRegion(e) {
     setNewJob({
       ...newJob,
       is_in_region: e.target.value === 'YES',
     });
     setSelectedIsInRegion(e.target.value);
     onIsInRegionSelected(e.target.value);
   }

   function handleChangeSelectOrderNo(e) {
     var code = 'N/A';
     if (e.target.value === '0') {
       code = getSiteName();
     }
     else if (e.target.value === '1') {
       code = 'GET ON SITE';
     }
     else if (e.target.value === '2') {
       code = 'TBA BY KEY CONTACT';
     }
     else {
       code = '';
     }

     setNewJob({
       ...newJob,
       code:  code,
     });
     setSelectedOrderNo(e.target.value);
   }

   function validateCalendarOnChange(start, finish) {
      var isEmpty = start === undefined || finish === undefined || start === null || finish === null;
     //var d1 = new Date(start);
     //var d2 = new Date(finish);
     setIsTimeRangeInvalid(isEmpty || start >= finish);
   }

   function validateRegion() {
     setNoRegionSelectedError(selectedRegionId === undefined || selectedRegionId === null || selectedRegionId <= 0);
   }

  async function handleSubmit (e) {
     const errors = validate(newJob.contact, newJob.franchise_id, newJob.start, newJob.finish, selectedRegionId, newJob.instructions, newJob.testing_scopes, newJob.testing_scope_other_notes, newJob.code);
     if (errors.length > 0) {
         console.error('has error');
         return;
     }console.log('handleSubmit', newJob);
     onJobDetailsCreated(newJob);
   }

    function validate(contact, franchiseId, start, finish, selectedRegionId, instructions, testingScopes, testingScopeOtherNotes, po) {
      const errors = [];
      if (contact === undefined || contact === null || contact === '') {
        setNewJob({
          ...newJob,
          contact: '',
        });
          errors.push("Contact can't be empty");
      }

      if (franchiseId === undefined || franchiseId === null || franchiseId <= 0) {
        setNewJob({
          ...newJob,
          franchise_id: -1,
        });
        errors.push("Region can't be empty");
      }

      if (start === undefined || start === null || start === '') {
        setNewJob({
          ...newJob,
          start: '',
        });
          errors.push("Please select a start time");
      }

      if (finish === undefined || finish === null || finish === '') {
        setNewJob({
          ...newJob,
          finish: '',
        });
          errors.push("Please select a finish time");
      }

      if (instructions === undefined || instructions === null || instructions === '') {
        setNewJob({
          ...newJob,
          instructions: '',
        });
          errors.push("Instructions can't be empty");
      }

      var d1 = new Date(start);
      var d2 = new Date(finish);

      if (d1 >= d2) {
        errors.push("Finish time cannot be earlier than start time");
        setIsTimeRangeInvalid(true);
      }
      else {
        setIsTimeRangeInvalid(false);
      }

      if (selectedRegionId === undefined || selectedRegionId === null || selectedRegionId <= 0) {
        setNewJob({
          ...newJob,
          franchise_id: -1
        });
        errors.push("Please select a region");
      }

      if (testingScopes === undefined || testingScopes === null || testingScopes.length <= 0) {
        errors.push("Please select a service");
      }
      else {
        if ((testingScopes.find(item => item !== undefined && item !== null && (item.name !== undefined && item.name !== null && item.name.toLowerCase().includes('please make a note'))) !== undefined) &&
          (testingScopeOtherNotes === undefined || testingScopeOtherNotes === null || testingScopeOtherNotes === '')) {
            errors.push("Please specify other service");
        }
      }

      if (po === undefined || po === null || po === '' || po.trim() === '') {
        setNewJob({
          ...newJob,
          po: '',
        });
          errors.push("PO can't be empty");
      }

        return errors;
    }

    function onBlurRegionSelection() {
      validateRegion();
    }

    // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
    function handleChangeStart(d) {//console.log('handleChangeStart',d, selectedStart);
        currentStartValue = d;
        saveStart();
    }

    // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
    function handleChangeFinish(d) {//console.log('handleChangeFinish', d)
      currentFinishValue = d;
      saveFinish();
    }

    function blurStart(d) {//console.log('blurStart',d);
      setStartOpen(false);
      if (selectedStart === undefined) {
        setSelectedStart(null);
      }
    }

    function focusStart(event) {
      setStartOpen(true);
    }

    function blurFinish(d) {
      setFinishOpen(false);
      if (selectedFinish === undefined) {
        setSelectedFinish(null);
      }
    }

    function focusFinish(event) {
      setFinishOpen(true);
    }

    function saveStart() {//console.log('saveStart');
      var d = currentStartValue !== undefined && currentStartValue !== null ? new Date(currentStartValue) : currentStartValue;
      setSelectedStart(d);
      if (d !== undefined && d !== null && selectedFinish !== undefined && selectedFinish !== null) {
        validateCalendarOnChange(d, selectedFinish);
      }

      if (d !== null) {
        let [date, month, year] = d.toLocaleDateString('en-NZ').split("/")
        let [hour, minute] = d.toLocaleTimeString('en-NZ').slice(0,7).split(":")
        setNewJob({
          ...newJob,
          start: `${year}-${month}-${date} ${d.toLocaleTimeString('en-NZ').toLowerCase().includes('am') ? hour : (parseInt(hour) == 12 ? 12 : parseInt(hour)+12)}:${minute}`,
        });
      }
    }

    function saveFinish() {
      var d = currentFinishValue !== undefined && currentFinishValue !== null ? new Date(currentFinishValue) : currentFinishValue;
      setSelectedFinish(d);
      if (d !== undefined && d !== null && selectedStart !== undefined && selectedStart !== null) {
        validateCalendarOnChange(selectedStart, d);
      }
      if (d !== null) {
        let [date, month, year] = d.toLocaleDateString('en-NZ').split("/")
        let [hour, minute] = d.toLocaleTimeString('en-NZ').slice(0,7).split(":")
        setNewJob({
          ...newJob,
          finish: `${year}-${month}-${date} ${d.toLocaleTimeString('en-NZ').toLowerCase().includes('am') ? hour : (parseInt(hour) == 12 ? 12 : parseInt(hour)+12)}:${minute}`,
        });
      }
    }

    function onClickHasImportantInstructionSwitch() {
        setNewJob({
          ...newJob,
          has_important_instruction: newJob.has_important_instruction === undefined || newJob.has_important_instruction === null ? true : !newJob.has_important_instruction
        });
    }

    function onClickJsaRequiredSwitch() {
        setNewJob({
          ...newJob,
          jsa_required: newJob.jsa_required === undefined || newJob.jsa_required === null ? true : !newJob.jsa_required
        });
    }

    function onClickMicrowaveOnlySwitch() {
        setNewJob({
          ...newJob,
          microwave_only: newJob.microwave_only === undefined || newJob.microwave_only === null ? true : !newJob.microwave_only
        });
    }

    function onClickIsNFCSwitch() {
        setNewJob({
          ...newJob,
          is_nfc: newJob.is_nfc === undefined || newJob.is_nfc === null ? true : !newJob.is_nfc
        });
    }

    function onClickIsCataloguingSwitch() {
        setNewJob({
          ...newJob,
          is_cataloguing: newJob.is_cataloguing === undefined || newJob.is_cataloguing === null ? true : !newJob.is_cataloguing
        });
    }

    function onTestingScopesSelected(testingScopes) {
        const hasTELtag = Array.isArray(testingScopes) && testingScopes.some(scope => scope.id === 11);

        const updatedJob = {
          ...newJob,
          testing_scopes: testingScopes,
        };

        // the following two setups must come with TELtag
        if (hasTELtag) {
          updatedJob.is_nfc = true;
          updatedJob.is_cataloguing = true;
        }

        setNewJob(updatedJob);
        setTestScopesSelected(testingScopes);
    }

    function onOtherTestingScopesSpecified(otherTestingScopeNotes) {
      setNewJob({
        ...newJob,
        testing_scope_other_notes: otherTestingScopeNotes,
      });
    }

  return (
    <div className={classes.contentDiv}>
    {/*<div>{`newJob.id is ${newJob.id}`}</div>
    <div>{`newJob.customerId is ${newJob.customer_id}`}</div>
    <div>{`newJob.siteId is ${newJob.site_id}`}</div>
    <div>{`newJob.regionId is ${newJob.franchiseId}`}</div>
    <div>{`newJob.tag is ${newJob.tag}`}</div>
    <div>{`newJob.start is ${newJob.start}`}</div>
    <div>{`newJob.finish is ${newJob.finish}`}</div>
    <div>{`newJob.contact is ${newJob.contact}`}</div>
    <div>{`newJob.franchise_id is ${newJob.franchise_id}`}</div>*/}

    <form
        ref={formRef}
        onSubmit={handleSubmit}>

                <div className={classes.formDisplay}>
                  <div className={classes.calendars}>
                    <div style={{ marginBottom: props.compact ? 10 : 20 }}>
                      <div className={classnames({
                          'MuiFormControl-root': true, 'MuiTextField-root': true, 'textField': true, 'calendarField': true,
                          [classes.errorOther]: selectedStart === null || (selectedStart !== null && isTimeRangeInvalid),
                        })}>
                        <label className={classnames({
                            'MuiFormLabel-root': true, 'MuiInputLabel-root': true, 'MuiInputLabel-formControl': true, 'MuiInputLabel-animated': true,
                             'MuiInputLabel-shrink': true, 'MuiInputLabel-outlined': true, 'Mui-required': true,
                            [classes.errorOther]: selectedStart === null || (selectedStart !== null && isTimeRangeInvalid),
                          })}
                        data-shrink="true" htmlFor="start" id="start-label">Start<span aria-hidden="true" className="MuiFormLabel-asterisk MuiInputLabel-asterisk"> *</span></label>
                        <div className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl">
                          <div className="react-datepicker-wrapper">
                            <div className="react-datepicker__input-container">
                            <CalendarTodayIcon className="calendarIcon"/>
                            <DatePicker
                            ref={startCalendarRef}
                            className={classnames({
                            'textField': true,
                            [classes.errorOther]: selectedStart === null || (selectedStart !== null && isTimeRangeInvalid),
                          })}
                            selected={selectedStart}
                            onChange={handleChangeStart}
                            onBlur={blurStart}
                            onFocus={focusStart}
                            locale="en-NZ"
                            showTimeSelect
                            timeIntervals={30}
                            dateFormat="dd/MM/yyyy hh:mm aa"/>
                            </div>
                          </div>

                        </div>
                      </div>
                      <FormHelperText className={classes.errorOther}>{selectedStart === null ? 'Required' : (isTimeRangeInvalid ? 'Please make sure the start time is earlier than finish time.' : '')}</FormHelperText>
                    </div>

                    <div style={{ marginBottom: props.compact ? 10 : 20 }}>
                      <div className={classnames({
                          'MuiFormControl-root': true, 'MuiTextField-root': true, 'textField': true, 'calendarField': true,
                          [classes.errorOther]: selectedFinish === null,
                        })}>
                        <label className={classnames({
                            'MuiFormLabel-root': true, 'MuiInputLabel-root': true, 'MuiInputLabel-formControl': true, 'MuiInputLabel-animated': true,
                             'MuiInputLabel-shrink': true, 'MuiInputLabel-outlined': true, 'Mui-required': true,
                            [classes.errorOther]: selectedFinish === null,
                          })}
                          data-shrink="true" htmlFor="finish" id="finish-label">Finish<span aria-hidden="true" className="MuiFormLabel-asterisk MuiInputLabel-asterisk"> *</span></label>

                        <div className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl">
                          <div className="react-datepicker-wrapper">
                            <div className="react-datepicker__input-container">
                            <CalendarTodayIcon className="calendarIcon"/>
                            <DatePicker
                            ref={finishCalendarRef}
                            className={classnames({
                            'textField': true,
                            [classes.errorOther]: selectedFinish === null
                          })}
                            selected={selectedFinish}
                            onChange={handleChangeFinish}
                            onBlur={blurFinish}
                            onFocus={focusFinish}
                            locale="en-NZ"
                            showTimeSelect
                            timeIntervals={30}
                            dateFormat="dd/MM/yyyy hh:mm aa"
                            />
                            </div>
                          </div>

                        </div>
                      </div>
                      {selectedFinish === null && <FormHelperText className={classes.errorOther}>{selectedFinish === null ? 'Required' : ''}</FormHelperText>}
                      </div>
                    </div>

                <div className={classes.order} style={{ marginBottom: props.compact ? 10 : 20}}>
                  <FormControl variant="outlined" className={classnames({
                        'orderNoSelect':  true,
                        'select-control': true
                      })}>
                    <InputLabel id="order_no_select">PO?</InputLabel>
                    <div className={classnames({
                                  'select-control-input': true
                                })}>
                      <NativeSelect
                        value={selectedOrderNo}
                        onChange={handleChangeSelectOrderNo}
                      >
                         <option disabled value="-1"> -- select an option -- </option>
                         <option disabled={customer !== undefined && customer !== null && customer.po_required ? true : false} value="0">Not required</option>
                         <option value="1">YES, GET ON SITE</option>
                         <option value="2">YES, TBA BY KEY CONTACT</option>
                         <option value="3">YES, PROVIDED</option>
                      </NativeSelect>
                    </div>
                    {customer !== undefined && customer !== null &&
                      customer.po_required &&
                      <div style={{color: '#f44336'}}>PO is REQUIRED!</div>}
                  </FormControl>

                  <div>
                  <TextField
                    style={{width: '100%'}}
                    ref={orderNumberRef}
                    id="code"
                    label="Order No."
                    required
                    autoComplete='off'
                    onChange={handleChange}
                    name="code"
                    value={newJob.code || ''}
                    error={newJob.code === ''}
                    variant="outlined"
                    size="small"
                    disabled={disableOrderNumberField}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ReceiptIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  {newJob.code && newJob.code.trim() === '' && <FormHelperText className={classes.errorOther}>{newJob.code.trim() === '' ? 'Please enter the PO accordingly.' : ' '}</FormHelperText>}
                  </div>

                </div>



                  <TextField
                    id="contact"
                    label="Contact"
                    autoComplete='off'
                    onChange={handleChange}
                    name="contact"
                    value={newJob.contact || ''}
                    error={newJob.contact === ''}
                    variant="outlined"
                    required
                    size="small"
                    style={{ marginBottom: props.compact ? 10 : 20 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <ContactPhoneIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  {newJob.contact === '' && <FormHelperText className={props.compact ? classes.errorCompact : classes.error}>{newJob.contact === '' ? 'Please enter the contact for the job.' : ' '}</FormHelperText>}

                  {approvedLimitTypeMismatch && (
                    <div
                      style={{
                        color: '#f44336',
                        fontWeight: 500,
                        marginBottom: props.compact ? 10 : 20
                      }}
                    >
                      Customer budget limit type is now {
                        customer.approved_limit_type === 'TAGS'
                          ? 'Maximum Tags'
                          : 'Maximum Hours'
                      }. This job is currently set to {
                        newJob.approved_limit_type === 'TAGS'
                          ? 'Maximum Tags'
                          : 'Maximum Hours'
                      }. Please review before testing begins.
                    </div>
                  )}

                  {approvedLimitTypeForDisplay && (
                    <TextField
                      id="approvedLimitValue"
                      label={
                        approvedLimitTypeForDisplay === 'TAGS'
                          ? 'Approved Tag Limit'
                          : 'Approved Hour Limit'
                      }
                      autoComplete="off"
                      onChange={handleChange}
                      name="approved_limit_value"
                      value={
                        newJob.approved_limit_value === undefined ||
                        newJob.approved_limit_value === null
                          ? ''
                          : newJob.approved_limit_value
                      }
                      variant="outlined"
                      type="number"
                      size="small"
                      style={{ marginBottom: props.compact ? 10 : 20 }}
                      inputProps={{
                        min: approvedLimitTypeForDisplay === 'TAGS' ? 1 : 0.5,
                        step: approvedLimitTypeForDisplay === 'TAGS' ? 1 : 0.5
                      }}
                    />
                  )}

                  {approvedLimitTypeForDisplay &&
                   (
                     newJob.approved_limit_value === undefined ||
                     newJob.approved_limit_value === null ||
                     newJob.approved_limit_value === '' ||
                     Number(newJob.approved_limit_value) <= 0
                   ) && (
                    <div
                      style={{
                        color: '#f44336',
                        fontWeight: 500,
                        marginTop: props.compact ? -5 : -10,
                        marginBottom: props.compact ? 10 : 20
                      }}
                    >
                    {legacyApprovedLimitType
                      ? `Customer now requires an approved ${
                          approvedLimitTypeForDisplay === 'TAGS' ? 'tag' : 'hour'
                        } limit. This older job has no limit set. Please review before testing begins.`
                      : `Approved ${
                          approvedLimitTypeForDisplay === 'TAGS' ? 'tag' : 'hour'
                        } limit has not been entered. Please update this before testing begins.`
                      }
                    </div>
                  )}

                  <TextField
                    id="instructions"
                    name="instructions"
                    label="Instructions"
                    autoComplete='off'
                    value={newJob.instructions || ''}
                    error={newJob.instructions === ''}
                    multiline
                    rows="8"
                    variant="outlined"
                    required
                    onChange={handleChange}
                    size="small"
                    style={{ marginBottom: props.compact ? 10 : 20}}
                    InputProps={{
                      className: classes.textarea,
                      startAdornment: (
                        <InputAdornment position="start">
                          <MenuBookIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                  {newJob.instructions === '' && <FormHelperText className={props.compact ? classes.errorCompact : classes.error}>{newJob.instructions === '' ? 'Please enter the instructions for the job.' : ' '}</FormHelperText>}

                  {(!props.isEditJob) &&
                    customer.booking_instructions !== undefined && customer.booking_instructions != null &&
                    customer.booking_instructions !== '' &&
                    <TextField
                    id="booking_instructions"
                    name="booking instructions"
                    label="Booking Instructions"
                    autoComplete='off'
                    value={customer.booking_instructions || ''}
                    multiline
                    rows="5"
                    variant="outlined"
                    size="small"
                    style={{ marginBottom: props.compact ? 10 : 20}}
                    error={true}
                    InputProps={{
                      className: classes.textareaBookingInstructions,
                    }}
                  />}

                  <div className={classes.inline} style={{ marginBottom: props.compact ? 10 : 20}}>
                      <Box display={"flex"} alignItems={"center"} >

                          <Switch color={"primary"} checked={newJob.jsa_required}
                                  onClick={onClickJsaRequiredSwitch} />
                          <Typography weight={"medium"}>
                              JSA Required
                          </Typography>
                      </Box>

                      <Box display={"flex"} alignItems={"center"} >

                          <Switch color={"primary"} checked={newJob.microwave_only}
                                  onClick={onClickMicrowaveOnlySwitch} />
                          <Typography weight={"medium"}>
                              No Microwave LKG
                          </Typography>
                      </Box>

                      <Box display={"flex"} alignItems={"center"} >

                          <Switch color={"primary"} checked={newJob.has_important_instruction}
                                  onClick={onClickHasImportantInstructionSwitch} />
                          <Typography weight={"medium"}>
                              Important Instructions
                          </Typography>
                      </Box>

                      <Box display={"flex"} alignItems={"center"}>
                          <Switch color={"primary"} checked={newJob.is_nfc}
                                  onClick={onClickIsNFCSwitch} />
                          <Typography weight={"medium"}>
                              Job needs NFC tags
                          </Typography>
                      </Box>

                      <Box display={"flex"} alignItems={"center"}>
                          <Switch color={"primary"} checked={newJob.is_cataloguing}
                                  onClick={onClickIsCataloguingSwitch} />
                          <Typography weight={"medium"}>
                              No electrical testing
                          </Typography>
                      </Box>
                  </div>

                  <div className={classes.inline} style={{ marginBottom: props.compact ? 10 : 20}}>
                  {/*<FormControl variant="outlined" className="select-control" style={{ marginBottom: props.compact ? 10 : 20}}>

                    <div id="tag-select-control-input" className="select-control-input">

                      <InputAdornment position="start">
                        <LabelIcon />
                      </InputAdornment>
                      <InputLabel id="tag">Tags</InputLabel>
                      <NativeSelect
                        value={newJob.tag === undefined || newJob.tag === null ? '' : newJob.tag}
                        onChange={handleChange}
                        inputProps={{
                          name: 'tag',
                          id: 'tag',
                        }}
                      >
                        <option aria-label="None" value="" />
                        <option value={'Blue'}>Blue</option>
                        <option value={'Gray'}>Gray</option>
                        <option value={'Green'}>Green</option>
                        <option value={'Orange'}>Orange</option>
                        <option value={'Red'}>Red</option>
                        <option value={'White'}>White</option>
                        <option value={'Yellow'}>Yellow</option>
                      </NativeSelect>
                    </div>
                  </FormControl>*/}

                  <div className={classes.testingScopes}>
                    <SelectJobTestingScopes ref={selectJobTestingScopesRef}
                                     required={true}
                                     isAddJob={newJob.id === undefined || newJob.id === null}
                                     job={newJob}
                                     onTestingScopesSelected={onTestingScopesSelected}
                                     onOtherTestingScopesSpecified={onOtherTestingScopesSpecified}/>
                  </div>

                  </div>

                  <div className={classes.inline} style={{ marginBottom: props.compact ? 10 : 20}}>
                    <FormControl variant="outlined" className={classnames({
                          'isInRegionSelect':  true,
                          'select-control': true
                        })}>
                      <InputLabel id="is_in_region">Use In-Region Workers</InputLabel>
                      <div className={classnames({
                                    'select-control-input': true
                                  })}>
                        <NativeSelect
                          value={selectedIsInRegion}
                          onChange={handleChangeIsInRegion}
                        >
                           <option value="YES">YES</option>
                           <option value="NO">NO</option>
                        </NativeSelect>
                      </div>
                    </FormControl>

                    <FormControl variant="outlined"
                                  className={classnames({
                                    [classes.errorOther]: noRegionSelectedError,
                                    'select-control': true
                                  })}>
                      <InputLabel id="region">Scheduling Zone / Region<sup>*</sup></InputLabel>
                      <div className={classnames({
                                    [classes.errorOther]: noRegionSelectedError,
                                    'select-control-input': true
                                  })}>
                        <InputAdornment position="start">
                          <HomeWorkIcon />
                        </InputAdornment>
                        <NativeSelect
                          value={selectedRegionId}
                          onChange={handleChangeRegion}
                          onBlur={onBlurRegionSelection}
                        >
                           {regionOptions}
                        </NativeSelect>
                      </div>
                      {noRegionSelectedError && <FormHelperText className={classes.errorOther}>You must select a region for the job!</FormHelperText>}
                    </FormControl>
                  </div>


                </div>

      </form>
    </div>
  );
//}
});
export default JobDetails;
